import ko from 'knockout';
import templateMarkup from 'raw-loader!./webexsites-widget.html';

    function WebexsitesWidget(params) {

        var self = this;
        self.dataProvider = params.dataProvider;
        self.inpOutValue = params.inpOutValue;
        self.webexSites = ko.observableArray([]);
        var setMode = false;

        self.selectedWebexSite = ko.observable();

        function fillWebexSites() {

            self.dataProvider.getWebExSites().then(function (retObj) {

                self.webexSites(retObj);
                if (self.webexSites() && (self.webexSites().length > 0)) {
                    if (self.inpOutValue && self.inpOutValue() && self.inpOutValue().id) {
                        self.selectedWebexSite(self.inpOutValue().id);
                    } else {
                        self.selectedWebexSite(self.webexSites()[0].webexSystemID);
                        self.inpOutValue({ id: self.selectedWebexSite(), name:  self.webexSites()[0].SiteName});
                    }
                }
            }).catch(function(msg) {
                alert(msg);
            });
        }

        fillWebexSites();
        self.subscriptions = [];

        function getNameFromId(list, id) {

            if (!list || (id == null)) {
                return "";
            }

            for (var i = 0; i < list.length; i++) {
                if (list[i].webexSystemID == id)
                    return list[i].SiteName;
            } 

            return "";
        }

        self.subscriptions.push(
            self.selectedWebexSite.subscribe(function () {
                self.inpOutValue({ id: self.selectedWebexSite(), name: getNameFromId(self.webexSites(), self.selectedWebexSite()) });
            }));

        self.subscriptions.push(self.inpOutValue.subscribe(function () {
            if (setMode) {
                return;
            }

            setMode = true;

            if (self.inpOutValue && self.inpOutValue() && self.inpOutValue().id) {
                self.selectedWebexSite(self.inpOutValue().id);
            }

            setMode = false;
        }));
    }

    // This runs when the component is torn down. Put here any logic necessary to clean up,
  // for example cancelling setTimeouts or disposing Knockout subscriptions/computeds.
    WebexsitesWidget.prototype.dispose = function () {
        var self = this;
        self.subscriptions.forEach(function (sub) {
            sub.dispose();
        });
    };
  
  export default { viewModel: WebexsitesWidget, template: templateMarkup };
